import React from 'react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-186" data-mp="3kqnsmw4m036i">
      <div className="mx-auto max-w-5xl" data-id="element-187" data-mp="3ksgzocj4wpf1">
        <h2 className="text-center font-display text-[1.75rem] font-black leading-tight tracking-tight text-ink sm:text-[2.4rem]" data-id="element-188" data-mp="3fz5ndvvjzgfq">
          Cosa dicono i docenti
        </h2>
        <p className="mt-3 text-center text-sm font-medium text-ink/70" data-id="element-189" data-mp="36yzeyoepp6nf">
          <span aria-hidden="true" data-id="element-190" data-mp="370akasnt2mgn">⭐️⭐️⭐️⭐️⭐️</span> 4.9/5 · +1.500 docenti
        </p>

        <div className="mx-auto mt-10 grid max-w-4xl gap-5 sm:grid-cols-3" data-id="element-191" data-mp="31ybg5gk8rlin">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl bg-sand p-6" data-id="element-192" data-mp="2x1bgpohwdh0i">
              <div className="text-sm text-amber-500" aria-label="5 stelle su 5" data-id="element-193" data-mp="2s39reltvolgl">
                <span aria-hidden="true" data-id="element-194" data-mp="v8difd5cpw86">★ ★ ★ ★ ★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-display text-sm italic leading-relaxed text-ink/85" data-id="element-195" data-mp="q9u0roxsj6lm">
                &ldquo;{item.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-6" data-id="element-196" data-mp="m51fa3kbzrdp">
                <p className="text-xs font-bold text-ink" data-id="element-197" data-mp="m5sy0dstxumk">{item.name}</p>
                <p className="text-xs text-ink/50" data-id="element-198" data-mp="78aa1dnz7lg6">{item.location}</p>
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-8 text-center text-[11px] text-ink/40" data-id="element-199" data-mp="c7mz852bl4lx">
          Testimonianze illustrative a scopo dimostrativo.
        </p>
      </div>
    </section>;
}